import type { ProductPublic } from './supabase';

/** Public-facing model. The database SKU remains the stable internal key. */
export function productModel(product: Pick<ProductPublic, 'sku' | 'specs' | 'custom_fields'>): string {
  const specs = product.specs ?? {};
  const fields = product.custom_fields ?? {};
  return String(
    specs.modelo
      ?? specs.modelo_proveedor
      ?? specs.supplier_model
      ?? fields.modelo
      ?? fields.supplier_model
      ?? product.sku
  ).trim();
}
